import { Option } from "../../../../interfaces";
import parse from "html-react-parser";

type OptionQuestionTriviaProps = {
  option: Option;
  selectOption: (option: string) => void;
  isSelect?: boolean;
  index: number;
};

export const OptionQuestionTrivia = ({
  option,
  selectOption,
  isSelect,
  index,
}: OptionQuestionTriviaProps) => {
  const onSelectOption = () => {
    selectOption(option.id);
  };

  return (
    <li
      onClick={onSelectOption}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        paddingLeft: "15px",
        paddingRight: "15px",
        borderRadius: "6px",
        marginLeft: "30px",
        marginRight: "30px",
        marginBottom: "3px",
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
        backgroundColor: isSelect ? "black" : "transparent",
        color: isSelect ? "white" : "black",
      }}
    >

      <input
        type="radio"
        id={option.id}
        name="radio-group"
        style={{ display: "none" }}
        checked={isSelect}
        readOnly
      />

      
      <span style={{ fontWeight: "bold" }}>{index + 1}.</span>

     
      <label htmlFor={option.id} style={{ cursor: "pointer", flex: 1 }}>
        {parse(option.texto)}
      </label>
    </li>
  );
};
